var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeso(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1509_550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 0.202148V5.57701L15.1466 13.4359L1 21.7049H12.656C16.3804 21.7049 19.3969 19.0588 19.3969 15.7942V10.9552L1 0.202148Z",
    fill: "url(#paint0_linear_1509_550)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 0.202148L19.3969 10.9552V6.11286C19.3969 2.84824 16.3771 0.202148 12.656 0.202148H1Z",
    fill: "url(#paint1_linear_1509_550)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.678 10.9541L1 16.329V21.7039L15.1466 13.4349L10.678 10.9541Z",
    fill: "url(#paint2_linear_1509_550)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1509_550",
    x1: 5.52244,
    y1: 5.03793,
    x2: 11.9213,
    y2: 20.4917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1509_550",
    x1: 8.52422,
    y1: 5.14719,
    x2: 20.428,
    y2: 2.00281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0283FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01C2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1509_550",
    x1: 4.43309,
    y1: 19.7124,
    x2: 21.1046,
    y2: -2.40942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0157FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1509_550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21.5967,
    fill: "white",
    transform: "translate(0 0.202148)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeso);
export default __webpack_public_path__ + "static/media/Deso.a8468f308b972921df69d5b87303ace8.svg";
export { ForwardRef as ReactComponent };